import { all, call, put, select, spawn, takeEvery } from 'redux-saga/effects'

import UserActions from './actions'
import {
  assignMemberToProvider,
  clinicSetState,
  deviceSetState,
  forgotPasswordSendCode,
  forgotPasswordSubmit,
  getLinkedProviders,
  inviteMember,
  memberSetState,
  menuSetState,
  profileSetState,
  revokeProvider,
  shareMember,
  unlinkProvider,
  userSetState,
  verifyAttributeEmailCode,
  verifyEmail,
} from '../actions'
import { GET_MEMBERS, GET_USER_LIST } from '../member/sagas'
import { CLOSE_SOCKET, LISTEN_TO_SOCKET } from '../socket/sagas'
import { CLOSE_DB_SOCKET, LISTEN_TO_DB_SOCKET } from '../dashboadLiveRR/sagas'
import { GET_CLINICID, GET_CLINICS } from '../clinic/sagas'
import login, { currentAccount, logout, Verification } from '../../services/user'
import { getLeftMenuData } from '../../services/menu'
import { getBrowserOffSet, notification } from '../../services/index'

const getUser = (state) => state.user

export function* LOGIN({ payload }) {
  let { email = '' } = payload
  const { password } = payload
  email = email.trim()
  yield put(userSetState({ loading: true, newPassReq: false }))

  const success = yield call(login, email, password, payload)
  if (success.success) {
    yield put(
      userSetState({
        OTPReq: false,
        retainedValues: {},
      }),
    )
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })

    notification.success(`Logged In`)
  } else if (success.newPassReq) {
    yield put(
      userSetState({
        loading: false,
        newPassReq: true,
        userDetails: success.userDetails,
      }),
    )
  } else if (success.OTPReq) {
    yield put(
      userSetState({
        loading: false,
        OTPReq: true,
        retainedValues: payload,
        userDetails: success.userDetails,
      }),
    )
  } else {
    yield put(userSetState({ loading: false }))
  }
}

export function* VERIFICATION({ payload }) {
  yield put(userSetState({ loading: true, newPassReq: false }))

  const success = yield call(Verification, payload)
  if (success && success.success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield put(
      userSetState({
        OTPReq: false,
      }),
    )

    notification.success(`Logged In`)
  } else if (success.OTPReq) {
    yield put(
      userSetState({
        loading: false,
        OTPReq: true,
        userDetails: success.userDetails,
      }),
    )
  }
}

export function* FORGETPASSWORD_SEND_CODE({ payload }) {
  const { username } = payload
  yield put(userSetState({ forgetPasswordLoading: true }))

  const response = yield call(forgotPasswordSendCode, username)

  if (response.status === 403) {
    if (response.err.code === 'UserNotFoundException') {
      notification.warning('User not found', 'Email is not registered to our platform')
      yield put(userSetState({ forgetPasswordLoading: false }))
    } else {
      notification.warning(response.err.name, response.err.message)
      yield put(userSetState({ forgetPasswordLoading: false }))
    }
  } else if (response.status === 200) {
    notification.success('Recovery Code sent', 'Please check your email for the recovery code')
    return yield put(
      userSetState({
        forgetPasswordLoading: false,
        forgetPasswordUsername: username,
        forgetPasswordState: 'codeSent',
      }),
    )
  }

  yield put(userSetState({ forgetPasswordLoading: false }))
}

export function* FORGOTPASSWORD_SUBMIT({ payload }) {
  yield put(userSetState({ forgetPasswordLoading: true }))

  const { code, password, username } = payload

  const response = yield call(forgotPasswordSubmit, username, code, password)

  if (response.status === 403) {
    notification.warning(response.err.name, response.err.message)
  } else if (response.status === 200) {
    notification.success(
      'Password Changed',
      'Password Changed successfully, please login using your new password.',
    )
    return yield put(
      userSetState({ forgetPasswordLoading: false, forgetPasswordState: 'passwordChanged' }),
    )
  }

  yield put(userSetState({ forgetPasswordLoading: false }))
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put(userSetState({ loading: true }))
  let response = yield call(currentAccount)
  if (!response) {
    response = {
      status: false,
    }
  }
  if (response.status) {
    yield put(
      userSetState({
        OTPReq: false,
      }),
    )
    const { fullName, CoachImage, jwtToken } = response
    let userType = 'Provider'
    let isSA = false
    let isAdminFeature = false
    if (response.groups) {
      response.groups.map((group) => {
        if (group === 'superadmin-feature') {
          isAdminFeature = true
        }
        if (group === 'sa') {
          userType = 'Superadmin'
          isSA = true
          return true
        }
        if (group === 'member') {
          if (response.groups.length === 1) {
            userType = 'Member'
          }
          return true
        }
        if (group === 'clinic') {
          userType = 'Clinic'
          return true
        }
        return false
      })
    }
    let menuLeftData = yield call(getLeftMenuData, userType, isSA)
    menuLeftData = menuLeftData.filter((datum) => datum.display !== false)

    yield put(menuSetState({ menuLeftData }))

    yield put(
      userSetState({
        name: fullName,
        id: response.userID,
        CoachImage,
        role: userType,
        authorized: true,
        token: jwtToken,
        isSA,
        isAdminFeature,
      }),
    )

    yield put(userSetState({ details: [] }))
    if (isSA || (userType !== 'Clinic' && userType !== 'Member')) {
      yield all([
        put(userSetState({ pauseLoading: true, loading: false })),
        put(clinicSetState({ loading: true })),
        put(deviceSetState({ inventoryLoading: true })),
      ])
      yield call(GET_CLINICS)
      yield call(GET_USER_LIST, { payload: {} })
    } else if (userType === 'Clinic') {
      yield call(GET_CLINICID, { payload: {} })

      yield spawn(LISTEN_TO_SOCKET, {
        payload: {
          jwtToken,
        },
      })
      yield spawn(LISTEN_TO_DB_SOCKET, {
        payload: {
          jwtToken,
        },
      })
      const profileTimezone = getBrowserOffSet()
      yield put(profileSetState({ profileTimezone }))
      yield put(userSetState({ pauseLoading: true, loading: false }))
    }
  }
  return yield put(userSetState({ pauseLoading: true, loading: false }))
}
export function* LOGOUT() {
  yield call(logout)
  yield call(CLOSE_SOCKET)
  yield call(CLOSE_DB_SOCKET)
  if (typeof Storage !== 'undefined') {
    localStorage.removeItem('selectedClinic')
  }
  yield put(memberSetState({ activeMembers: [], members: [], lastFormValues: {} }))
  yield put(
    userSetState({
      details: {},
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    }),
  )
}

export function* EMAIL_VERIFY_SEND_CODE({ payload }) {
  const { email } = payload
  yield put(userSetState({ emailVerifyCodeLoading: true }))

  const response = yield call(verifyAttributeEmailCode, email)

  if (response.status === 403) {
    notification.warning(response.err.name, response.err.message)
    yield put(userSetState({ emailVerifyCodeLoading: false }))
  } else if (response.status === 200) {
    notification.success(
      'Verification Code sent',
      'Please check your email for the verification code',
    )
    return yield put(userSetState({ emailVerifyCodeLoading: false, emailVerifyState: 'codeSent' }))
  }

  yield put(userSetState({ emailVerifyCodeLoading: false }))
}

export function* EMAIL_VERIFY_SUBMIT({ payload }) {
  const { email } = payload
  yield put(userSetState({ emailVerifyLoading: true }))

  const response = yield call(verifyEmail, email)

  if (response.status === 403) {
    notification.warning(response.err.name, response.err.message)
    yield put(userSetState({ emailVerifyLoading: false }))
  } else if (response.status === 200) {
    notification.success('Email Verified', 'your email is verified')
    return yield put(
      userSetState({
        emailVerifyLoading: false,
        emailVerifyState: 'emailVerified',
      }),
    )
  }

  yield put(userSetState({ emailVerifyLoading: false }))
}

export function* INVITE_NEW_MEMBER({ payload }) {
  yield put(userSetState({ inviteModalLoading: true }))

  const { role } = yield select(getUser)
  const { data } = payload

  yield call(inviteMember, data, role)
  yield put(userSetState({ inviteModalLoading: false, inviteModalVisible: false }))
}

export function* SHARE_MEMBER({ payload }) {
  yield put(userSetState({ shareModalLoading: true }))

  const { role } = yield select(getUser)
  const { data } = payload
  yield call(shareMember, data, role)

  yield put(
    userSetState({
      shareModalLoading: false,
      shareModalVisible: false,
    }),
  )
  yield call(GET_MEMBERS, {
    payload: {
      data: {
        vcstatus: true,
      },
    },
  })
}

export function* REVOKE_PROVIDER({ payload }) {
  const { role } = yield select(getUser)
  const { data } = payload

  yield call(revokeProvider, data, role)
  yield call(GET_MEMBERS, {
    payload: {
      data: {
        vcstatus: true,
      },
    },
  })
}

export function* ASSIGN_MEMBER_TO_PROVIDER({ payload }) {
  yield put(userSetState({ assignModalLoading: true }))

  const { role } = yield select(getUser)
  const { data } = payload
  yield call(assignMemberToProvider, data, role)

  yield put(
    userSetState({
      assignModalLoading: false,
      assignModalVisible: false,
    }),
  )
  yield call(GET_MEMBERS, {
    payload: {
      data: {
        vcstatus: true,
      },
    },
  })
}

export function* GET_LINKED_PROVIDERS({ payload }) {
  yield put(userSetState({ linkedProvidersModalLoading: true }))

  const { role } = yield select(getUser)
  const { data } = payload

  const linkedProviders = yield call(getLinkedProviders, data, role)

  yield put(userSetState({ linkedProvidersModalLoading: false, linkedProviders }))
}

export function* UNLINK_PROVIDER({ payload }) {
  yield put(userSetState({ linkedProvidersModalLoading: true }))

  const { role, linkedProvidersMemberID } = yield select(getUser)
  const { data } = payload
  yield call(unlinkProvider, data, role)

  yield call(GET_LINKED_PROVIDERS, {
    payload: {
      data: {
        member_id: linkedProvidersMemberID,
      },
    },
  })

  yield put(userSetState({ linkedProvidersModalLoading: false }))
}

export function LOG_ACTION({ type = '' }) {
  const split = type.split('/')
  const { location } = window
  const { hostname } = location

  if (
    type !== '@@router/LOCATION_CHANGE' &&
    split[1] !== 'SET_STATE' &&
    hostname === 'cns.virtualsleepclinic.com'
  ) {
    // ReactGA.event({
    //   category: split[0],
    //   action: split[1],
    // })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(UserActions.LOGIN, LOGIN),
    takeEvery(UserActions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(UserActions.LOGOUT, LOGOUT),
    takeEvery(UserActions.FORGETPASSWORD_SEND_CODE, FORGETPASSWORD_SEND_CODE),
    takeEvery(UserActions.FORGOTPASSWORD_SUBMIT, FORGOTPASSWORD_SUBMIT),
    takeEvery(UserActions.EMAIL_VERIFY_SEND_CODE, EMAIL_VERIFY_SEND_CODE),
    takeEvery(UserActions.EMAIL_VERIFY_SUBMIT, EMAIL_VERIFY_SUBMIT),
    takeEvery(UserActions.INVITE_NEW_MEMBER, INVITE_NEW_MEMBER),
    takeEvery(UserActions.ASSIGN_MEMBER_TO_PROVIDER, ASSIGN_MEMBER_TO_PROVIDER),
    takeEvery(UserActions.SHARE_MEMBER, SHARE_MEMBER),
    takeEvery(UserActions.REVOKE_PROVIDER, REVOKE_PROVIDER),
    takeEvery(UserActions.GET_LINKED_PROVIDERS, GET_LINKED_PROVIDERS),
    takeEvery(UserActions.UNLINK_PROVIDER, UNLINK_PROVIDER),
    takeEvery(UserActions.VERIFICATION, VERIFICATION),
    takeEvery('*', LOG_ACTION),
    yield call(LOAD_CURRENT_ACCOUNT), // run once on app load to check user auth,
  ])
}
